<template>
    <div class="dashboard__market-charts">
        <div class="card card--with-heading">
            <div class="heading">
                <h3>
                    Precio de referencia capón
                    <span>Incluye categoría MEI</span>
                </h3>
                <DashboardFilters
                    ref="filtersComponent"
                    @filter="getGraphDashboard"
                    :dashboardTab="dashboardTab"
                    :isAdmin="isAdmin"
                    :filterFor="filterFor"
                />
            </div>
            <div v-if="dashboardGraph[0].lastOperationPrice" class="last-price">
                <span>Precio última operación del período</span>
                <strong>
                    $/Kg sin IVA {{ dashboardGraph[0].lastOperationPrice }}
                </strong>
            </div>
            <div v-if="!dashboardGraph[0].results[0]">
                No hay gráficos para mostrar
            </div>
            <div v-if="dashboardGraph" class="chart-wrapper">
                <div class="chart" v-if="values.length">
                    <apexchart
                        type="area"
                        width="100%"
                        height="300"
                        :options="chartOptions"
                        :series="series"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DashboardFilters from "@/components/dashboard/DashboardFilters.vue";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const graphDashboard = gql`
    query graphDashboard(
        $currentUserToken: String!
        $scope: String!
        $scopedOrganizationId: Int
        $filters: DashboardFilterInput
    ) {
        graphDashboard(
            currentUserToken: $currentUserToken
            scope: $scope
            scopedOrganizationId: $scopedOrganizationId
            filters: $filters
        ) {
            lastOperationPrice
            name
            results {
                day
                value
            }
        }
    }
`;

export default {
    name: "chart-market-dashboard",
    components: {
        apexchart: VueApexCharts,
        DashboardFilters,
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        filterFor: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            series: [
                {
                    name: "Precio",
                    data: [],
                },
            ],
            chartOptions: {
                colors: ["#D3726B", "#E91E63", "#9C27B0"],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "smooth",
                },
                xaxis: {
                    type: "datetime",
                    categories: [],
                },
                fill: {
                    colors: ["#f6f0e6", "#E91E63", "#9C27B0"],
                },
            },
            dashboardGraph: [{ results: [] }],
            dashboardDays: [],
            productType: "",
        };
    },
    computed: {
        days() {
            if (this.dashboardGraph.length) {
                let dateArr = this.dashboardGraph
                    .find((a) => a.name == "Precio")
                    .results.map((e) => e.day);
                this.chartOptions = {
                    ...this.chartOptions,
                    ...{ xaxis: { categories: dateArr } },
                };
                return this.dashboardGraph
                    .find((a) => a.name == "Precio")
                    .results.map((e) => e.day);
            }
            return [];
        },
        values() {
            if (this.dashboardGraph[0]) {
                if (this.dashboardGraph[0].results.length) {
                    return this.dashboardGraph
                        .find((capon) => capon.name == "Precio")
                        .results.map((e) => Number(e.value));
                }
            }
            return [];
        },
    },
    watch: {
        dashboardGraph() {
            this.getDays();
        },
    },
    methods: {
        getGraphDashboard(productType = "Precio capón") {
            var filter = this.$refs.filtersComponent;

            // esto se agregó porque por algun motivo se mandaban peticiones con el weekFrom de esa seamana.
            // Se debería ver porque pasa eso y despues borrar esta línea.
            if (filter.invertedWeekFrom === "190149") return;
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(graphDashboard),
                        variables: {
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            scope: this.dashboardTab,
                            filters: {
                                weekFrom: filter.invertedWeekFrom,
                                weekTo: filter.invertedWeekTo,
                                state: "finished",
                                category: [
                                    "MEI (Macho Entero Inmunocastrado)",
                                    "Capones",
                                ],
                            },
                        },
                    },
                })
                .then((res) => {
                    this.dashboardGraph = res.data.data.graphDashboard;
                    this.series = [
                        {
                            data: this.dashboardGraph
                                .find((a) => a.name == "Precio")
                                .results.map((e) => Number(e.value)),
                            name: "Precio",
                        },
                    ];
                })
                .catch((err) => {
                    //console.log(err)
                });
        },
        getDays(type = "Precio") {
            let arr = [];
            var dGraph = this.dashboardGraph
                ? this.dashboardGraph.find((a) => a.name == type)
                : [];
            let dateArr = dGraph ? dGraph.results.map((e) => e.day) : [];
            this.chartOptions = {
                ...this.chartOptions,
                ...{ xaxis: { categories: dateArr } },
            };
        },
    },
};
</script>
